import { useQuery } from "@tanstack/react-query"
import { privateApi } from "../../../api/api";
import { ErrorResponse } from "../response/ErrorResponse";
import { RoleResponse } from "../response/RoleResponse";

interface useRoleByIdProps {
    id: number | undefined;
}

export const useRoleById = ({ id }: useRoleByIdProps) => {
    return useQuery({
        queryKey: ['role', id],
        queryFn: async () => {
            try {
                const response = await privateApi.get(`/v4/role/${id}`, {
                    params: {
                        include: "permissions,users"
                    }
                });

                const validationResult = RoleResponse.safeParse(response.data);

                if (!validationResult.success) {
                    console.error("Validation failed:", validationResult.error.errors);
                    throw new Error("Invalid role data format");
                }

                return validationResult.data;
            } catch (error) {
                const validationResult = ErrorResponse.safeParse((error as any).response?.data);

                if (!validationResult.success) {
                    console.error("Validation failed:", validationResult.error.errors);
                    throw new Error("Invalid error response format");
                } else {
                    console.error('Failed to fetch role', error);
                    throw error;
                }

            }
        },
        enabled: !!id,
        retry: import.meta.env.VITE_MAX_RETRY,
    });
}